import React from "react";
import { HomeBannerStyles } from "../Styles";
import { getMeaning } from "../../utils/localization";
import BlogHeroCardTwo from "../BlogHero/BlogHeroCardTwo";
import { Box, Grid, Paper, Typography } from "@mui/material";
import Heading from "../Heading";
import GlobalSubHeading from "../GlobalSubHeading";
import GlobalDescription from "../GlobalDescription";

const BlogDetailsTwo = (BlogId) => {
  return (
    <Box style={{ flex: 1, marginTop: 100 }}>
      <Box>
        <BlogHeroCardTwo />
      </Box>

      <Box
        maxWidth="xlg"
        sx={[
          // ReImagineStyles.root,
          { py: 5, background: "#fff", width: "100%" },
        ]}
      >
        <Box sx={{ mx: { xs: 3, md: 11 } }} mb={3}>
          <Box align="center">
            <Heading title={getMeaning("BLGDTLSONE.HDNG")} />
          </Box>

          <GlobalSubHeading
            subTitle={getMeaning("BLGDTLSONE.DSCRPTN")}
            ParentContainer={{}}
            textSx={{
              textAlign: "justify",
              width: { xs: "100%", sm: "100%", md: "100%" },
            }}
          />

          {/* <GlobalSubHeading subTitle={getMeaning("BLGDTLSONE.DSCRPTN")} /> */}
          {/* <Typography sx={HomeBannerStyles.bannerTitle}>
            {getMeaning("BLGDTLSONE.HDNG")}
          </Typography> */}

          {/* <Typography mt={2} sx={TailoredStyles.description}> */}
          {/* <Typography sx={HomeBannerStyles.bannerDescription} align="left">
            {getMeaning("BLGDTLSONE.DSCRPTN")}
          </Typography> */}
        </Box>

        <Grid
          sx={{
            mx: { xs: 2, md: 4 },
            display: { md: "flex" },
            alignItems: { md: "center" },
            justifyContent: { md: "center" },
          }}
          // display="flex"
          // alignItems="center"
          // justifyContent="center"
        >
          <Grid sx={{ mx: { xs: 0, md: 7 } }} item xs={12} md={7}>
            <Box sx={{ mx: -1 }}>
              <Heading title={getMeaning("BLGDTLSONE.INSRDPRSNHDNG")} />
            </Box>
            {/* <Typography
              variant="h5"
              gutterBottom
              // sx={{ fontFamily: '"Poppins",serif', fontWeight: 600 }}
              sx={HomeBannerStyles.BlckBannerTitle}
            >
              {getMeaning("BLGDTLSONE.INSRDPRSNHDNG")}
            </Typography> */}

            {/* Paragraph */}
            <GlobalDescription
              subTitle={getMeaning("BLGDTLSONE.INSRDPRSNSBHDNG")}
            />

            {/* <Typography
              variant="body1"
              mb={3}
              sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
            >
              {getMeaning("BLGDTLSONE.INSRDPRSNSBHDNG")}
            </Typography> */}

            {/* Quote */}
            <Paper
              elevation={2}
              sx={{
                backgroundColor: "#f8fbff",
                borderLeft: "5px solid #1976d2",
                px: 3,
                py: 3,
                mb: 3,
                mt: 3,
              }}
            >
              <Typography
                variant="body1"
                fontStyle="italic"
                sx={{
                  fontFamily: '"Poppins",serif',
                  fontWeight: 400,
                  textAlign: "justify",
                  fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
                }}
              >
                {getMeaning("BLGDTLSONE.VASITLCCRD")}
              </Typography>
            </Paper>

            {/* Bold label followed by normal text */}
            <GlobalDescription
              label={getMeaning("BLGDTLSONE.TYPOFVASDSCP1")}
              subLabel={getMeaning("BLGDTLSONE.TYPOFVASDSCP2")}
            />
            {/* <Typography
              variant="body1"
              sx={{ mb: 2, fontFamily: '"Poppins",serif', fontWeight: 400 }}
            >
              <strong>{getMeaning("BLGDTLSONE.TYPOFVASDSCP1")}</strong>{" "}
              {getMeaning("BLGDTLSONE.TYPOFVASDSCP2")}
            </Typography> */}

            <GlobalDescription
              label={getMeaning("BLGDTLSONE.WHYVAS1")}
              subLabel={getMeaning("BLGDTLSONE.WHYVAS2")}
            />
            {/* <Typography
              variant="body1"
              sx={{ mb: 2, fontFamily: '"Poppins",serif', fontWeight: 400 }}
            >
              <strong>{getMeaning("BLGDTLSONE.WHYVAS1")}</strong>{" "}
              {getMeaning("BLGDTLSONE.WHYVAS2")}
            </Typography> */}

            <GlobalDescription
              label={getMeaning("BLGDTLSONE.ULTRSMRTINS1")}
              subLabel={getMeaning("BLGDTLSONE.ULTRSMRTINS2")}
            />
            {/* <Typography
              variant="body1"
              sx={{ mb: 1, fontFamily: '"Poppins",serif', fontWeight: 400 }}
            >
              <strong>{getMeaning("BLGDTLSONE.ULTRSMRTINS1")}</strong>{" "}
              {getMeaning("BLGDTLSONE.ULTRSMRTINS2")}
            </Typography> */}

            {/* <Typography
              variant="body1"
              sx={{ mb: 2, fontFamily: '"Poppins",serif', fontWeight: 400 }}
            >
              <strong>{getMeaning("BLGDTLSONE.MRKTEXPNSN1")}</strong>{" "}
              {getMeaning("BLGDTLSONE.MRKTEXPNSN2")}
            </Typography> */}
            <GlobalDescription
              label={getMeaning("BLGDTLSONE.MRKTEXPNSN1")}
              subLabel={getMeaning("BLGDTLSONE.MRKTEXPNSN2")}
            />
          </Grid>

          {/* Image */}
          <Grid item xs={12} md={5}>
            <Box
              component="img"
              src={require("../../assets/images/Blog/BlogCoverImg.jpg")}
              alt="VAS in Insurance"
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: 2,
                boxShadow: 2,
              }}
            />
          </Grid>
        </Grid>

        <Box
          // mx={12}
          sx={{ mx: { xs: 3, sm: 3, md: 11 } }}
          mb={4}
          align="left"
        >
          <GlobalDescription label={getMeaning("BLGDTLSONE.GENZHDNG1")} />
          {/* <Typography
            variant="body1"
            sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            <strong>{getMeaning("BLGDTLSONE.GENZHDNG1")}</strong>
          </Typography> */}

          <GlobalDescription subLabel={getMeaning("BLGDTLSONE.GENZHDNG2")} />
          {/* <Typography
            variant="body1"
            sx={{ mb: 2, fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            {getMeaning("BLGDTLSONE.GENZHDNG2")}
          </Typography> */}
        </Box>

        <Box
          // mx={12}
          sx={{ mx: { xs: 3, sm: 3, md: 11 } }}
          mb={2}
          align="left"
        >
          <GlobalDescription label={getMeaning("BLGDTLSONE.BNFTSOFVAS1")} />
          <GlobalDescription subLabel={getMeaning("BLGDTLSONE.BNFTSOFVAS2")} />

          {/* <Typography
            variant="body1"
            sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            <strong>{getMeaning("BLGDTLSONE.BNFTSOFVAS1")}</strong>
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            {getMeaning("BLGDTLSONE.BNFTSOFVAS2")}
          </Typography> */}

          {/* <Typography
            variant="body1"
            sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            <strong>• {getMeaning("BLGDTLSONE.PRDTDIFF1")} </strong>{" "}
            {getMeaning("BLGDTLSONE.PRDTDIFF2")}
          </Typography> */}
          <GlobalDescription
            name={getMeaning("BLGDTLSONE.PRDTDIFF1")}
            description={getMeaning("BLGDTLSONE.PRDTDIFF2")}
          />

          {/* <Typography
            variant="body1"
            sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            <strong>• {getMeaning("BLGDTLSONE.ADRVNUSTRM1")} </strong>{" "}
            {getMeaning("BLGDTLSONE.ADRVNUSTRM2")}
          </Typography>
           */}
          <GlobalDescription
            name={getMeaning("BLGDTLSONE.ADRVNUSTRM1")}
            description={getMeaning("BLGDTLSONE.ADRVNUSTRM2")}
          />

          <Typography
            variant="body1"
            sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            <strong>• {getMeaning("BLGDTLSONE.AQUITETNTN1")} </strong>{" "}
            {getMeaning("BLGDTLSONE.AQUITETNTN2")}
          </Typography>
          <GlobalDescription
            name={getMeaning("BLGDTLSONE.AQUITETNTN1")}
            description={getMeaning("BLGDTLSONE.AQUITETNTN2")}
          />

          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Poppins",serif',
              fontWeight: 400,
              fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
              mx: 1.5,
            }}
          >
            {getMeaning("BLGDTLSONE.BNFTSOFVAS3")}
          </Typography>
        </Box>

        <Box sx={{ mx: { xs: 3, sm: 3, md: 12 } }} mb={0} align="left">
          <Typography
            variant="body1"
            sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            <strong>{getMeaning("BLGDTLSONE.MTNGGENZLBL")}</strong>
          </Typography>

          <Typography
            variant="body1"
            sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            {getMeaning("BLGDTLSONE.MTNGGENZDSCRPTN1")}{" "}
            {getMeaning("BLGDTLSONE.MTNGGENZDSCRPTN2")}
          </Typography>

          <Typography
            variant="body1"
            sx={{ mt: 2, fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            <strong>{getMeaning("BLGDTLSONE.FTRFRINSURERLBL")}</strong>
          </Typography>

          <Typography
            variant="body1"
            sx={{ fontFamily: '"Poppins",serif', fontWeight: 400 }}
          >
            {getMeaning("BLGDTLSONE.FTRFRINSURERLBL1")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Poppins",serif',
              fontWeight: 400,
              fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
            }}
          >
            <strong>• {getMeaning("BLGDTLSONE.PRSNLSTN1")} </strong>{" "}
            {getMeaning("BLGDTLSONE.PRSNLSTN2")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Poppins",serif',
              fontWeight: 400,
              fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
            }}
          >
            <strong>• {getMeaning("BLGDTLSONE.INVTVDGTLPRDCT1")} </strong>{" "}
            {getMeaning("BLGDTLSONE.INVTVDGTLPRDCT2")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Poppins",serif',
              fontWeight: 400,
              fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
            }}
          >
            <strong>• {getMeaning("BLGDTLSONE.HLSTC1")} </strong>{" "}
            {getMeaning("BLGDTLSONE.HLSTC2")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Poppins",serif',
              fontWeight: 400,
              fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
            }}
          >
            <strong>• {getMeaning("BLGDTLSONE.CLBRTVPRTNRSHP1")} </strong>{" "}
            {getMeaning("BLGDTLSONE.CLBRTVPRTNRSHP2")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Poppins",serif',
              fontWeight: 400,
              fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
            }}
          >
            <strong>• {getMeaning("BLGDTLSONE.TRNSPRNCYEDCTN1")} </strong>{" "}
            {getMeaning("BLGDTLSONE.TRNSPRNCYEDCTN2")}
          </Typography>

          {/* ****** Conclusion Label ****** */}
          <>
            <Typography variant="body1" sx={styles.CnclsnLabelTxt}>
              <strong>{getMeaning("BLGDTLSONE.CNCLSN")} </strong>
            </Typography>

            <Typography
              variant="body1"
              sx={[
                HomeBannerStyles.BannerDescriptionTwo,
                { fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" } },
              ]}
            >
              {getMeaning("BLGDTLSONE.CNCLSNDSCRPTN")}
            </Typography>
          </>
        </Box>
      </Box>
    </Box>
  );
};

export default BlogDetailsTwo;

const styles = {
  CnclsnLabelTxt: {
    mt: 2,
    fontFamily: '"Poppins",serif',
    fontWeight: 400,
    fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
  },
};
